import deps from "../depsloader";

export default () => {
  deps.load("lightgallery").then(() => {
    const elms = document.querySelectorAll(".lightgallery");
    if (!elms || elms.length == 0) {
      return;
    }

    for (let element of elms) {
      let config = null;
      if (element.dataset.config) {
        config = element.dataset.config;
        element.removeAttribute("data-config");
      }

      lightGallery(element, JSON.parse(config)); // eslint-disable-line
    }

    const exposeBtn = document.querySelector("#exGalleryBtn");
    if (exposeBtn) {
      exposeBtn.addEventListener("click", function(e) {
        e.preventDefault();
        const gallery = document.querySelector("#exGallery");
        if (gallery) {
          gallery.firstElementChild.click();
        }
      })
    }
  });
}
